export default "__VITE_ASSET__c436104b__"